module.exports = __webpack_public_path__ + "static/img/dinner1-big.4b2d155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/dinner1-big.jpg
// module id = 2bY1
// module chunks = 0